export default __webpack_public_path__ + "static/media/vale-refeicao-ben-refeicao.61749504.png";